import type { Country, Destination } from '@/shared/model';
import type { ApiOption } from './types';

export function adaptDestination(
  { id, name, type, country }: ApiOption,
  countryNameById?: ReadonlyMap<number, string>,
): Destination | null {
  switch (type) {
    case 'country': {
      return {
        type: 'country',
        country: {
          id,
          name,
          isPopular: false,
          position: null,
          visaRequired: false,
          visaOnline: false,
          visaDays: null,
          minPrice: null,
        },
        resort: null,
        hotel: null,
      };
    }
    case 'resort': {
      return {
        type: 'resort',
        country: null,
        resort: {
          id,
          name,
          countryId: country,
          countryName: countryNameById?.get(country) ?? '',
          isPopular: false,
          atFiltering: false,
          minPrice: null,
        },
        hotel: null,
      };
    }
    case 'hotel': {
      return {
        type: 'hotel',
        country: null,
        resort: null,
        hotel: {
          id,
          name,
          countryId: country,
          countryName: countryNameById?.get(country) ?? '',
        },
      };
    }
    default: {
      return null;
    }
  }
}

export function adaptDestinations(list: ApiOption[], countries: Country[] = []): Destination[] {
  const countryNameById = new Map<number, string>(countries.map((country) => [country.id, country.name]));
  return list.map((item) => adaptDestination(item, countryNameById)).filter(Boolean) as Destination[];
}
